import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from "../actions/action";

const defaultState = {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
};

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        user: action.payload.user,
      };

    case LOGOUT_SUCCESS:
      return { ...state, isAuthenticated: false, user: null, accessToken: null, refreshToken: null, cart: 0 };
    default:
      return state;
  }
};

export default authReducer;
